import api from '../axiosConfig';
import { BOOKING_ENGINE } from '../config/apiEndpoints';

const getHeaders = (tenantId) => {
    return tenantId ? { headers: { 'x-tenant-id': String(tenantId) } } : {};
};

export const BookingEngineService = {
    /**
     * Search room availability & meal plan pricing
     */
    searchAvailability: async (params = {}) => {
        try {
            const tenantId = params.tenantId || params.id;
            const config = {
                params,
                ...getHeaders(tenantId)
            };
            const response = await api.get(BOOKING_ENGINE.SEARCH, config);
            return response.data;
        } catch (error) {
            console.error('BookingEngineService searchAvailability error:', error);
            throw error;
        }
    },

    /**
     * Fetch hotel profile & branding
     */
    getHotelProfile: async (hotelId) => {
        try {
            const url = hotelId ? `${BOOKING_ENGINE.HOTELS}/${hotelId}` : BOOKING_ENGINE.HOTEL;
            const config = getHeaders(hotelId);
            const response = await api.get(url, config);
            return response.data;
        } catch (error) {
            console.error('BookingEngineService getHotelProfile error:', error);
            throw error;
        }
    },

    /**
     * Validate promotional code
     */
    validatePromoCode: async (payload = {}) => {
        try {
            const config = getHeaders(payload.tenantId);
            const response = await api.post(BOOKING_ENGINE.VALIDATE_PROMO, payload, config);
            return response.data;
        } catch (error) {
            console.error('BookingEngineService validatePromoCode error:', error);
            throw error;
        }
    },

    /**
     * Create direct guest reservation ("Proceed to Book")
     */
    createReservation: async (reservationData = {}) => {
        try {
            const config = getHeaders(reservationData.tenantId);
            const response = await api.post(BOOKING_ENGINE.RESERVATIONS, reservationData, config);
            return response.data;
        } catch (error) {
            console.error('BookingEngineService createReservation error:', error);
            throw error;
        }
    },

    /**
     * Get booking voucher summary for PDF rendering
     */
    getVoucher: async (bookingReference, tenantId) => {
        try {
            const config = getHeaders(tenantId);
            const response = await api.get(BOOKING_ENGINE.VOUCHER(bookingReference), config);
            return response.data;
        } catch (error) {
            console.error('BookingEngineService getVoucher error:', error);
            throw error;
        }
    },

    /**
     * Submit room enquiry lead ("Enquire")
     */
    submitEnquiry: async (enquiryData = {}) => {
        try {
            const config = getHeaders(enquiryData.tenantId);
            const response = await api.post(BOOKING_ENGINE.ENQUIRY, enquiryData, config);
            return response.data;
        } catch (error) {
            console.error('BookingEngineService submitEnquiry error:', error);
            throw error;
        }
    },

    /**
     * Initiate Razorpay payment order
     */
    initiateRazorpayPayment: async (payload = {}) => {
        try {
            const config = getHeaders(payload.tenantId);
            const response = await api.post(BOOKING_ENGINE.INITIATE_RAZORPAY, payload, config);
            return response.data;
        } catch (error) {
            console.error('BookingEngineService initiateRazorpayPayment error:', error);
            throw error;
        }
    },

    /**
     * Verify Razorpay payment signature
     */
    verifyRazorpayPayment: async (payload = {}) => {
        try {
            const config = getHeaders(payload.tenantId);
            const response = await api.post(BOOKING_ENGINE.VERIFY_RAZORPAY, payload, config);
            return response.data;
        } catch (error) {
            console.error('BookingEngineService verifyRazorpayPayment error:', error);
            throw error;
        }
    }
};


export default BookingEngineService;
